import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 29,
	viewBox: "0 0 34 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M32.5946 28.1065C32.5877 28.1059 32.5821 28.1059 32.5765 28.1065H1.40603C0.896633 28.1065 0.426708 27.8315 0.178588 27.386C-0.0701592 26.9411 -0.0582544 26.3966 0.20929 25.963L15.7939 0.66792C16.0495 0.252506 16.5032 0 16.9913 0C17.4781 0 17.9324 0.252506 18.188 0.66792L33.6667 25.792C33.8747 26.0376 34 26.354 34 26.7011C34.0007 27.4768 33.3716 28.1065 32.5946 28.1065ZM3.9242 25.2945H30.0577L16.9913 4.08584L3.9242 25.2945Z",
		fill: "#EC0000"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.99 21.4204C17.3559 21.4204 17.6679 21.5489 17.9248 21.8039C18.1805 22.062 18.3089 22.3722 18.3089 22.7375C18.3089 23.1047 18.173 23.4148 17.9029 23.673C17.631 23.9273 17.3271 24.0564 16.99 24.0564C16.6535 24.0564 16.3496 23.9273 16.0783 23.673C15.8077 23.4148 15.6736 23.1047 15.6736 22.7375C15.6736 22.3722 15.8008 22.062 16.0577 21.8039C16.3133 21.5483 16.6241 21.4204 16.99 21.4204ZM17.9129 19.5752H16.0683V8.37032H17.9129V19.5752Z",
		fill: "#EC0000"
	})]
});
export default SvgWarningIcon;
